<div style="width: 100%; height: 100%">
    <div  id="delete-modal" *ngIf="modalTitle == 'Add Service Rate'" [formGroup]="serviceForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Default Service</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Service</mat-label>
                <mat-select formControlName="service_rate_service" style="width: 100%;">
                    <mat-option *ngFor="let item of getServices()" [value]="item">{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Service Type</mat-label>
                <mat-select formControlName="service_rate_service_type" style="width: 100%;">
                    <mat-option *ngFor="let item of getServiceType(serviceForm.get('service_rate_service')?.value)"
                        [value]="item">{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Flat Rate</mat-label>
                <input matInput type="number" formControlName="flat_rate" placeholder="Start Typing Flat Rate...">
            </mat-form-field>            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="createService()" >Create</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Edit Shipment Details'" [formGroup]="editShipmentForm">
        <div class = "edit-modal">
            <div class="edit-modal-inner">
                <div class="edit-modal-content">
                    <mat-label style = "font-size: 16px;">Edit Shipment Details</mat-label>
                </div>  
                <br>          
                <mat-form-field style="width: 50%;">
                    <mat-label>ASN Number</mat-label>
                    <mat-select style="width: 100%;" formControlName="asn_number">
                        <mat-option *ngFor="let item of asn_array"
                            [value]='item.asn_number'>{{item.asn_number}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="width: 50%;">
                    <mat-label>Store Number</mat-label>
                    <mat-select style="width: 100%;" formControlName="store_number">
                        <mat-option *ngFor="let item of store_array" [value]='item'>{{item}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="width: 33%;">
                    <mat-label>Delivery Day</mat-label>
                    <mat-select style="width: 100%;" formControlName="appointment_day">
                        <mat-option value=''></mat-option>
                        <mat-option value='Monday'>Monday</mat-option>
                        <mat-option value='Tuesday'>Tuesday</mat-option>
                        <mat-option value='Wednesday'>Wednesday</mat-option>
                        <mat-option value='Thursday'>Thursday</mat-option>
                        <mat-option value='Friday'>Friday</mat-option>
                        <mat-option value='Saturday'>Saturday</mat-option>
                        <mat-option value='Sunday'>Sunday</mat-option>
                    </mat-select>
                </mat-form-field>           
                <mat-form-field style="width: 33%;">
                    <mat-label>Appointment Start</mat-label>
                    <input matInput type="time" formControlName="appointment_start" placeholder="Start Typing Appointment Start...">
                </mat-form-field>
                <mat-form-field style="width: 33%;">
                    <mat-label>Appointment End</mat-label>
                    <input matInput type="time" formControlName="appointment_end" placeholder="Start Typing Appointment End...">
                </mat-form-field>
                <mat-form-field style="width: 50%;">
                    <mat-label>Consolidate fastfrate</mat-label>
                    <mat-select style="width: 100%;" formControlName="express_road">
                        <mat-option value=''></mat-option>
                        <mat-option value='Express Road'>Express Road</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="width: 50%;">
                    <mat-label>Carbon Fuel Tax</mat-label>
                    <mat-select style="width: 100%;" formControlName="carbon_fuel_tax">
                        <mat-option value='Alberta'>Alberta Carbon Fuel Tax Applied</mat-option>
                        <mat-option value='BC'>BC Carbon Fuel Tax Applied</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="width: 100%;">
                    <mat-label>Default Carrier</mat-label>
                    <input matInput formControlName="carrier_contact_uuid" placeholder="Start Typing Default Carrier...">
                </mat-form-field>          
                <mat-form-field style="width: 100%;">
                    <mat-label>Bill Of Lading</mat-label>
                    <input matInput formControlName="external_bill_of_lading"
                        placeholder="Start Typing External Bill Of Lading...">
                </mat-form-field>      
                <mat-form-field style="width: 50%;">
                    <mat-label>Total Weight</mat-label>
                    <input matInput formControlName="reported_weight" placeholder="Start Typing the total Weight...">
                </mat-form-field>                      
                <mat-form-field style="width: 50%;">
                    <mat-label>Expected No. Of Carton</mat-label>
                    <input matInput formControlName="total_cartons" placeholder="Start Typing Expected No. Of Carton...">
                </mat-form-field>                                                                                                             
                <div class="edit-modal-buttons">
                    <button type="button" class="confirm"  (click)="editShipment()" >Save</button>
                    <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Edit Trip Shipment'" [formGroup]="editTripShipmentForm">
        <div class = "edit-modal">
            <div class="edit-modal-inner">
                <div class="edit-modal-content">
                    <mat-label style = "font-size: 16px;">Edit Shipment Details</mat-label>
                </div>  
                <br>          
                <mat-form-field style="width: 100%;">
                    <mat-label>ACT Trailer No.</mat-label>
                    <input matInput formControlName="act_trail_number"
                        placeholder="Start Typing Trailer Number...">
                    <input matInput type="string" formControlName="shipment_list_uuid" hidden>    
                </mat-form-field>      
                <mat-form-field style="width: 100%;">
                    <mat-label>Bill Of Lading</mat-label>
                    <input matInput formControlName="external_bill_of_lading"
                        placeholder="Start Typing External Bill Of Lading...">
                </mat-form-field>                  
                <div class="edit-modal-buttons">
                    <button type="button" class="confirm"  (click)="editTripShipment()" >Save</button>
                    <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Add Pallet'" [formGroup]="palletForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add a Pallet</mat-label>
            </div><br>                
            <mat-form-field style="width: 100%;">
                <mat-label>Carton Count</mat-label>
                <input matInput formControlName="carton_count" placeholder="Start Typing Carton Count...">
            </mat-form-field>    
            <mat-form-field style="width: 33.3%;">
                <mat-label>Height</mat-label>
                <input matInput formControlName="dimension_height" placeholder="Start Typing Height...">
            </mat-form-field>
            <mat-form-field style="width: 33.3%;">
                <mat-label>Length</mat-label>
                <input matInput formControlName="dimension_length" placeholder="Start Typing Length...">
            </mat-form-field>
            <mat-form-field style="width: 33.3%;">
                <mat-label>Width</mat-label>
                <input matInput formControlName="dimension_width" placeholder="Start Typing Width...">
            </mat-form-field>            
            <mat-form-field style="width: 100%;">
                <mat-label>Total Weight</mat-label>
                <input matInput formControlName="load_weight" placeholder="Start Typing Total Weight...">
            </mat-form-field>        
            <mat-form-field style="width: 100%;">
                <mat-label>Load No</mat-label>
                <mat-select style="width: 100%;" formControlName="load_no">
                    <mat-option value=''></mat-option>
                    <mat-option value='01'>01</mat-option>
                    <mat-option value='02'>02</mat-option>
                    <mat-option value='03'>03</mat-option>
                </mat-select>
            </mat-form-field>                                
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="submitNewPallet()" >Create</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Add Multiple Pallets'" [formGroup]="multiplepalletsForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add Multiple Pallet<br>Note: It will delete the existing Palles</mat-label>
            </div><br>                
            <mat-form-field style="width: 100%;">
                <mat-label>No of Pallets</mat-label>
                <input matInput formControlName="no_of_pallets" placeholder="Start Typing No of Pallets...">
            </mat-form-field>    
            <mat-form-field style="width: 33.3%;">
                <mat-label>Height</mat-label>
                <input matInput formControlName="dimension_height" placeholder="Start Typing Height...">
            </mat-form-field>
            <mat-form-field style="width: 33.3%;">
                <mat-label>Length</mat-label>
                <input matInput formControlName="dimension_length" placeholder="Start Typing Length...">
            </mat-form-field>
            <mat-form-field style="width: 33.3%;">
                <mat-label>Width</mat-label>
                <input matInput formControlName="dimension_width" placeholder="Start Typing Width...">
            </mat-form-field>            
            <mat-form-field style="width: 100%;">
                <mat-label>Average Carton Weight</mat-label>
                <input matInput formControlName="carton_weight" placeholder="Start Typing Average Carton Weight...">
            </mat-form-field>        
            <mat-form-field style="width: 100%;">
                <mat-label>Total Weight</mat-label>
                <input matInput formControlName="total_weight" placeholder="Start Typing Total Weight...">
            </mat-form-field>                 
            <mat-form-field style="width: 100%;">
                <mat-label>Load No</mat-label>
                <mat-select style="width: 100%;" formControlName="load_no">
                    <mat-option value=''></mat-option>
                    <mat-option value='01'>01</mat-option>
                    <mat-option value='02'>02</mat-option>
                    <mat-option value='03'>03</mat-option>
                </mat-select>
            </mat-form-field>                                
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="submitMultiplePallets()" >Create</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Edit Default Services'" [formGroup]="servicesForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit a Default Service</mat-label>
            </div><br>                
            <mat-form-field style="width: 100%;">                
                <mat-label>Service</mat-label>
                <input matInput type="string" formControlName="service" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
            </mat-form-field>  
            <mat-form-field style="width: 100%;">                
                    <mat-label>Service Type</mat-label>
                <input matInput type="string" formControlName="service_type" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_profile_default_service_uuid" hidden>                    
            </mat-form-field>        
            <mat-form-field style="width: 100%;">
                <mat-label>Flat Rate</mat-label>
                <input matInput formControlName="flat_rate" placeholder="Start Typing Flat Rate...">
            </mat-form-field>                                               
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editServiceRate()" >Save</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Edit Pallet'" [formGroup]="editPalletForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit a Pallet</mat-label>
            </div><br>                
            <mat-form-field style="width: 100%;">                
                <mat-label>Carton Count</mat-label>
                <input matInput formControlName="carton_count" placeholder="Start Typing Carton Count...">
                <input matInput type="string" formControlName="package_uuid" hidden>                    
            </mat-form-field>  
            <mat-form-field style="width: 33.3%;">
                <mat-label>Height</mat-label>
                <input matInput formControlName="dimension_height" placeholder="Start Typing Height...">
            </mat-form-field>        
            <mat-form-field style="width: 33.3%;">
                <mat-label>Length</mat-label>
                <input matInput formControlName="dimension_length" placeholder="Start Typing Length...">
            </mat-form-field>
            <mat-form-field style="width: 33.3%;">
                <mat-label>Width</mat-label>
                <input matInput formControlName="dimension_width" placeholder="Start Typing Width...">
            </mat-form-field>           
            <mat-form-field style="width: 100%;">
                <mat-label>Load No</mat-label>
                <mat-select style="width: 100%;" formControlName="load_no">
                    <mat-option value=''></mat-option>
                    <mat-option value='01'>01</mat-option>
                    <mat-option value='02'>02</mat-option>
                    <mat-option value='03'>03</mat-option>
                </mat-select>
            </mat-form-field>                                             
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editPallet()" >Save</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Add Barcode'" [formGroup]="deleteServiceRateForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Add a Barcode</mat-label>
            </div><br>                
            <mat-form-field style="width: 100%;">
                <mat-label>Pallet</mat-label>
                <mat-select [formControl]="pallet" style="width: 100%;">
                    <mat-option *ngFor="let item of pallets" [value]='item.id'>{{item.value}}</mat-option>
                </mat-select>
            </mat-form-field>    
            <mat-form-field style="width: 100%;">
                <mat-label>Barcode</mat-label>
                <input [formControl]="barcode" matInput placeholder="Start Typing Barcode...">
            </mat-form-field>                            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="createBarcode()" >Create</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Update Work Order Barcodes/Pallet'">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Update the Work Order's Barcodes and Pallets</mat-label>                          
            </div>  
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="updateBarcodesPallets()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="delete-modal" *ngIf="modalTitle == 'Change Barcodes Status'">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Default Barcode Status for Non Audited Barcodes</mat-label>
            </div>  
            <br>          
            <mat-form-field style="width: 100%;">
                <mat-label>Default Status</mat-label>
                <mat-select [formControl]="return_status" style="width: 100%;">
                    <mat-option *ngFor="let item of statuses" [value]="item">{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="changeBarcodeStatus()" >Update</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Move Barcode Onto Pallet'">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Move Unallocated Barcodes Onto Pallets</mat-label>                          
            </div>  
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="moveBarcodes()" >Move</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Trip List Confirmation'" [formGroup]="deleteTripForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Trip?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>ASN Number</mat-label>
                <input matInput type="string" formControlName="asn_number" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="trip_list_uuid" hidden >                    
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Trip Number</mat-label>
                <input matInput type="string" formControlName="trip_number" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
            </mat-form-field>            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteTrip()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Pallet Confirmation'" [formGroup]="deletePalletForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Pallet?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">
                <mat-label>Pallet No</mat-label>
                <input matInput type="string" formControlName="count" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="package_uuid" hidden >                    
            </mat-form-field>
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deletePallet()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Service Rate Confirmation'" [formGroup]="deleteServiceRateForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this Service?</mat-label>
            </div><br>
            <mat-form-field style="width: 100%;">                
                <mat-label>Service</mat-label>
                <input matInput type="string" formControlName="service" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
            </mat-form-field>  
            <mat-form-field style="width: 100%;">                
                    <mat-label>Service Type</mat-label>
                <input matInput type="string" formControlName="service_type" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="contact_profile_default_service_uuid" hidden>                    
            </mat-form-field>  
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteRate()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Delete Barcode Confirmation'" [formGroup]="deleteBarcodeForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Confirm to delete this barcode?<br><br></mat-label>
            </div><br>            
            <mat-form-field style="width: 100%;">        
                <mat-label>Barcode</mat-label>                           
                <input matInput type="string" formControlName="barcode" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="product_uuid" hidden>                   
            </mat-form-field> 
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="deleteBarcode()" >Delete</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>


    <!-- Upload ASN File -->
    <div *ngIf="modalTitle == 'Upload ASN File'" [formGroup]="uploadFileForm">
        <div class="upload-modal-inner ">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Customer</mat-label>
                <mat-select style="width: 100%;" formControlName="customer">
                    <mat-option value='Spencer'>Spencer Gifts</mat-option>
                    <mat-option value='Spirit'>Spencer Spirit</mat-option>
                </mat-select>
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Week No.</mat-label>
                <mat-select style="width: 100%;" formControlName="week_no">
                    <mat-option *ngFor="let item of week_array" [value]='item'>{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
        </span>  
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>File Type</mat-label>
                <mat-select style="width: 100%;" formControlName="file_type">
                    <mat-option value='ASN'>ASN</mat-option>
                    <mat-option value='Bearware'>Bearware</mat-option>
                    <mat-option value='Modified'>Modified</mat-option>
                    <mat-option value='Carry Over'>Carry Over</mat-option>
                </mat-select>
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Store No. For Carry Over</mat-label>
                <mat-select style="width: 100%;" formControlName="store_number">
                    <mat-option *ngFor="let item of []" [value]='item'>{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Manifest Carton Count</mat-label>
                <input type="number" matInput formControlName="manifest_carton_count"
                    placeholder="Start Typing Manifest Carton Count...">
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>BOL Carton Count</mat-label>
                <input type="number" matInput formControlName="bol_carton_count"
                    placeholder="Start Typing BOL Carton Count...">
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>ASN No. For Carry Over</mat-label>
                <input matInput formControlName="asn_number" placeholder="Start Typing ASN No. For Carry Over...">
            </mat-form-field>
        </span>
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Trailer ID</mat-label>
                <input matInput formControlName="trailer_id" placeholder="Start Typing Trailer ID...">
            </mat-form-field>
        </span>    
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Drop Trailer Work Order</mat-label>
                <input matInput formControlName="drop_trailer_alternate_reference" placeholder="Start Typing Drop Trailer Work Order No...">
            </mat-form-field>
        </span>            
        <span style="flex-basis: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Distribution Center</mat-label>
                <mat-select style="width: 100%;" formControlName="distribution_center_contact_uuid">
                    <mat-option value='1e659c26-bb11-4843-936a-08342a2fa31f'>SPENCER GIFTS</mat-option>
                    <mat-option value='e420767d-7549-4e52-a2fe-5d0036413dfc'>NFI - FREDERICKSBURG</mat-option>
                    <mat-option value='ec306721-2008-44f3-bb3f-d6a62c7f5aeb'>NFI - DELTA</mat-option>
                </mat-select>
            </mat-form-field>
        </span>        
        <input #fileInput type="file" (change)="onFileSelected($event)" style="font-size: large" mat-raised-button color="primary">
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="closeModal()" color="accent">Close</button>
            <button (click)="submitAsnFile()" mat-button color="primary">Upload</button>
        </span>
        </div>    
    </div>
    <div class="spinner-overlay" *ngIf="showSpinner">
            <!-- Spinner and loading text -->
            <mat-spinner diameter="20"></mat-spinner>
            <p>Loading...</p>
    </div>

    <!-- Upload Yoshino File -->
    <div *ngIf="modalTitle == 'Upload Yoshino File'" [formGroup]="uploadYoshinoForm">
        <div class="upload-modal-inner ">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <input #fileInput type="file" (change)="onFileSelected($event)" style="font-size: large" mat-raised-button color="primary">
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="closeModal()" color="accent">Close</button>
            <button (click)="submitYoshinoFile()" mat-button color="primary">Upload</button>
        </span>
        </div>    
    </div>
    <div class="spinner-overlay" *ngIf="showSpinner">
            <!-- Spinner and loading text -->
            <mat-spinner diameter="20"></mat-spinner>
            <p>Loading...</p>
    </div>

    <!-- Upload Inventory File -->
    <div *ngIf="modalTitle == 'Upload Inventory File'" [formGroup]="uploadFileForm">
        <div class="upload-modal-inner ">
        <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
        <input matInput type="string" formControlName="inventory_warehouse_uuid" hidden >   
        <input #fileInput type="file" (change)="onFileSelected($event)" style="font-size: large" mat-raised-button color="primary">
        <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
            <button mat-button (click)="closeModal()" color="accent">Close</button>
            <button (click)="submitInventoryFile()" mat-button color="primary">Upload</button>
        </span>
        </div>    
    </div>
    <div class="spinner-overlay" *ngIf="showSpinner">
            <!-- Spinner and loading text -->
            <mat-spinner diameter="20"></mat-spinner>
            <p>Loading...</p>
    </div>    


    <div *ngIf="modalTitle == 'Edit Trip Details'" [formGroup]="editTripDetailsForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Edit Trip Details</mat-label>
            </div><br>                
            <span style="flex-basis: 100%;">
                <mat-form-field style="width: 100%;">
                    <mat-label>Week No.</mat-label>
                    <mat-select style="width: 100%;" formControlName="week_no">
                        <mat-option  *ngFor="let item of week_array" 
                        [value]="item" 
                        [attr.selected]="item.selected== true ? true : null">
                        {{item}}                        
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </span>              
            <mat-form-field style="width: 100%;">                
                <mat-label>Manifest Carton Count</mat-label>
                <input matInput formControlName="manifest_carton_count" placeholder="Start Typing Manifest Carton Count...">
                <input matInput type="string" formControlName="trip_list_uuid" hidden>                    
            </mat-form-field>  
            <mat-form-field style="width: 100%;">   
                <mat-label>Bill of Lading Carton Count</mat-label>
                <input matInput formControlName="bol_carton_count" placeholder="Start Typing Bill of Lading Carton Count...">
            </mat-form-field>        
            <mat-form-field style="width: 100%;">   
                <mat-label>Trip Number</mat-label>
                <input matInput formControlName="trip_number" placeholder="Start Typing Trip Number...">
            </mat-form-field>
            <mat-form-field style="width: 100%;">   
                <mat-label>ASN Number</mat-label>
                <input matInput formControlName="asn_number" placeholder="Start Typing ASN Number...">
            </mat-form-field>           
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="editTripDetails()" >Save</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>


    <div *ngIf="modalTitle == 'Move Exception Carton'" [formGroup]="moveExceptionCartonForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Move An Exception Carton</mat-label>
            </div><br>                           
            <mat-form-field style="width: 100%;">        
                <mat-label>Barcode</mat-label>                           
                <input matInput type="string" formControlName="barcode" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 12px; width: 100%" >
                <input matInput type="string" formControlName="product_uuid" hidden>                   
            </mat-form-field>             
            <mat-form-field style="width: 100%;">   
                <mat-label>Trip Number</mat-label>
                <input matInput formControlName="trip_number" placeholder="Start Typing Trip Number...">
            </mat-form-field>
            <mat-form-field style="width: 100%;">   
                <mat-label>ASN Number</mat-label>
                <input matInput formControlName="asn_number" placeholder="Start Typing ASN Number...">
            </mat-form-field>           
            <mat-form-field style="width: 100%;">   
                <mat-label>Store Number</mat-label>
                <input matInput formControlName="store_number" placeholder="Start Typing the Store number...">
            </mat-form-field>        
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="moveExceptionCarton()" >Move</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Print Bill Of Lading'" [formGroup]="printBOLForm">
        <div class="delete-modal-inner">         
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Print a Bill Of Lading</mat-label>
            </div><br>                
            <mat-form-field style="width: 100%;">        
                <mat-label>Work Order Number</mat-label>                           
                <input matInput type="string" formControlName="alternate_reference" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 16px; width: 100%" >
                <input matInput type="string" formControlName="uuid" hidden>                   
            </mat-form-field> 
            <mat-form-field style="width: 100%;">
                <mat-label>Shipper</mat-label>
                <mat-select style="width: 100%;" formControlName="shipper_contact_uuid" style ="font-size: 12px; width: 100%">
                    <mat-option *ngFor="let item of shipper_array" [value]='item.shipper_contact_uuid'>{{item.shipper_name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Page</mat-label>
                <mat-select style="width: 100%;" formControlName="page_no">
                    <mat-option value='1' selected>First Page Only</mat-option>
                    <mat-option value='2'>Second Page Only</mat-option>
                    <mat-option value='0'>Both Pages</mat-option>
                </mat-select>
            </mat-form-field>            
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="printBOL()" >Print</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div *ngIf="modalTitle == 'Create EDI File'" [formGroup]="createEDIFileForm">
        <div class="delete-modal-inner">         
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Create An EDI File</mat-label>
            </div><br>            
            <mat-form-field style="width: 100%;">        
                <mat-label>Work Order Number</mat-label>                           
                <input matInput type="string" formControlName="alternate_reference" placeholder="" readonly style ="border: none transparent; outline: none; font-size: 16px; width: 100%" >
                <input matInput type="string" formControlName="lading_uuid" hidden>                   
            </mat-form-field>                          
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="submitCreateEDIFile()" >Create File</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

</div>
